module.exports = __webpack_public_path__ + "static/img/20150419-20150801.c34fbbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20150419-20150801.png
// module id = s2Xz
// module chunks = 1